import { render, staticRenderFns } from "./CeoMediaNews.vue?vue&type=template&id=efc04234&scoped=true&"
import script from "./CeoMediaNews.vue?vue&type=script&lang=js&"
export * from "./CeoMediaNews.vue?vue&type=script&lang=js&"
import style0 from "./CeoMediaNews.vue?vue&type=style&index=0&id=efc04234&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc04234",
  null
  
)

export default component.exports